// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"46ab46bf","838":"6aa2af3e"}[chunkId] + ".js";
};